import { SHButton } from "@components/design-systems";
import { ModelScreenerColumnSettingDTO } from "@models/model-screener/entities/modelScreenerFilter";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import { Badge, useTheme } from "@mui/material";
import { MSTableColumnSettingModal } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/modal";
import { RootState } from "@redux/store";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useToggle, useUnmount } from "react-use";

interface MSTableColumnSettingProps {
  currentColumnSettingData: ModelScreenerColumnSettingDTO;
  disabled?: boolean;
}

export const MSTableColumnSetting = ({
  currentColumnSettingData,
  disabled
}: MSTableColumnSettingProps) => {
  const { palette } = useTheme();
  const numOfHiddenColumns = useSelector(
    (state: RootState) => state.modelScreener.ui.numberOfColumnsApplied,
  );

  // States
  const [modalOpen, toggleModalOpen] = useToggle(false);

  // Forms
  const formMethod = useForm<ModelScreenerColumnSettingDTO>({
    mode: "onChange",
    defaultValues: currentColumnSettingData,
  });

  // Effects
  useEffect(() => {
    formMethod.reset(currentColumnSettingData);
  }, [currentColumnSettingData, formMethod]);

  useUnmount(() => {
    formMethod.reset(currentColumnSettingData);
  });

  return (
    <>
      <SHButton
        disabled={disabled}
        variant="outlined"
        size="extraMedium"
        startIcon={
          <CalendarViewWeekIcon
            sx={{
              width: 18,
              height: 18,
            }}
          />
        }
        endIcon={
          numOfHiddenColumns > 0 ? (
            <Badge
              badgeContent={numOfHiddenColumns}
              max={numOfHiddenColumns}
              sx={{
                ".MuiBadge-badge": {
                  position: "static",
                  backgroundColor: palette.warning.main,
                  color: palette.error.contrastText,
                  transform: "none",
                  minHeight: "22px",
                  minWidth: "22px",
                  paddingTop: "2px",
                  borderRadius: "100px",
                },
              }}
            />
          ) : null
        }
        onClick={toggleModalOpen}
      >
        Columns
      </SHButton>

      <FormProvider {...formMethod}>
        <MSTableColumnSettingModal
          msColumnSettings={currentColumnSettingData}
          open={modalOpen}
          onClose={toggleModalOpen}
        />
      </FormProvider>
    </>
  );
};
